import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  return (
    <div className="relative min-h-screen bg-background-primary text-text-primary antialiased flex flex-col font-sans overflow-hidden">
      <Helmet>
        <title>Privacy Policy | Just One Week Games</title>
        <meta
          name="description"
          content="Privacy Policy for Knight Survivor and Just One Week Games."
        />
        <meta name="robots" content="noindex" />
      </Helmet>

      {/* Background Video */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-background-primary/90 z-10" />
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          poster="/video-poster.png"
          className="w-full h-full object-cover opacity-30"
        >
          <source src="/bg-optimized.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="relative z-10 flex flex-col min-h-screen">
        <main className="container mx-auto px-4 py-12 flex-grow flex flex-col items-center">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-8 text-center"
          >
            <Link to="/">
              <img
                src="/JOW Games Pixelated.png"
                alt="Just One Week Games"
                className="h-24 mx-auto object-contain hover:opacity-80 transition-opacity"
              />
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="w-full max-w-4xl bg-background-card/80 backdrop-blur-md p-8 rounded-2xl border border-accent-secondary/20 shadow-xl"
          >
            <h1 className="text-3xl font-bold mb-8 text-accent-primary text-center">
              Privacy Policy
            </h1>

            <div className="prose prose-invert max-w-none text-text-secondary">
              <p>Last updated: {new Date().toLocaleDateString()}</p>

              <h2>1. Information We Collect</h2>
              <p>
                We collect information provided by Discord when you log in, such
                as your username and user ID. We do not collect or store
                passwords. We also collect data about your game progress and
                in-game activities.
              </p>

              <h2>2. How We Use Your Information</h2>
              <p>
                We use the information we collect to operate, maintain, and
                improve our games, to provide customer support, and to
                communicate with you.
              </p>

              <h2>3. Data Storage and Security</h2>
              <p>
                Your game progress is stored securely linked to your Discord ID.
                We take reasonable measures to help protect information about
                you from loss, theft, misuse, and unauthorized access. Since we
                do not manage credentials, your account security is primarily
                dependent on your Discord account security.
              </p>

              <h2>4. Third-Party Services</h2>
              <p>
                We may use third-party services for analytics and
                authentication. These services may collect information about
                your use of our games.
              </p>

              <h2>5. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please
                contact us at{' '}
                <a
                  href="mailto:info@jowgames.org"
                  className="text-accent-info hover:text-accent-primary"
                >
                  info@jowgames.org
                </a>
                .
              </p>
            </div>
          </motion.div>
        </main>

        <footer className="container mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between text-text-secondary text-sm">
          <div className="order-2 md:order-1 mt-4 md:mt-0 text-center md:text-left">
            <p>
              &copy; {new Date().getFullYear()} Just One Week Games. All rights
              reserved.
            </p>
            <div className="mt-2 flex gap-4 justify-center md:justify-start">
              <Link
                to="/terms"
                className="hover:text-accent-primary transition-colors"
              >
                Terms of Service
              </Link>
              <Link
                to="/privacy"
                className="hover:text-accent-primary transition-colors"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
